import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const Quotations = lazy(() => import('./QuotationForm'));
const SalesOrders = lazy(() => import('./SalesOrders'));
const SalesOrderForm = lazy(() => import('./SalesOrderForm'));
const Invoices = lazy(() => import('./Invoices'));
const SalesReturns = lazy(() => import('./SalesReturns'));
const SalesReceipts = lazy(() => import('./SalesReceipts'));
const CustomerRates = lazy(() => import('./CustomerRates'));
const InstallmentSales = lazy(() => import('./InstallmentSales'));

export const salesRoutes = (
    <React.Fragment key="sales">
        <Route element={<ProtectedRoute permission="sales.quotation.view" />}>
            <Route path="/quotations" element={<Quotations />} />
        </Route>
        <Route element={<ProtectedRoute permission="sales.order.view" />}>
            <Route path="/sales-orders" element={<SalesOrders />} />
            <Route path="/sales-orders/new" element={<SalesOrderForm />} />
            <Route path="/sales-orders/:id" element={<SalesOrderForm />} />
        </Route>
        <Route element={<ProtectedRoute permission="sales.invoice.view" />}>
            <Route path="/sales-invoices" element={<Invoices />} />
        </Route>
        <Route element={<ProtectedRoute permission="sales.return.view" />}>
            <Route path="/sales-returns" element={<SalesReturns />} />
        </Route>
        <Route element={<ProtectedRoute permission="sales.receipt.view" />}>
            <Route path="/sales/receipts" element={<SalesReceipts />} />
        </Route>
        <Route element={<ProtectedRoute permission="sales.customer_pricing.view" />}>
            <Route path="/sales/customer-rates" element={<CustomerRates />} />
        </Route>
        <Route element={<ProtectedRoute permission="sales.installment.view" />}>
            <Route path="/sales/installment-sales" element={<InstallmentSales />} />
        </Route>
    </React.Fragment>
);
